import "./LegalNotice.module.css";
import Header from "@/reusable_sections/Header";
import LegalOverview from "./sections/LegalOverview";
import LegalDetails from "./sections/LegalDetails";
import Footer from "@/reusable_sections/Footer";
export default function LegalNoticePage() {
  return <div>
      <Header />
      <LegalOverview />
      <LegalDetails />
      <Footer />
    </div>;
}